import React from "react";
import { Link } from "react-router-dom";
import {
  Table,
  InputGroup,
  FormControl,
  Button,
  Collapse,
} from "react-bootstrap";
import { observer, inject } from "mobx-react";

import "./Mapping.scss";

@inject("detailViewStore", "previewStore")
@observer
class Mapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      searchExpr: "",
      selectedItems: [],
    };
  }

  handleSearchExprChange = (searchExpr) => {
    this.setState({ searchExpr: searchExpr });
  };

  processEntityData = (entityData) => {
    if (
      !entityData ||
      !entityData.otherInformation ||
      !entityData.otherInformation.mappingsForCube
    )
      return [];

    const mappings = [];
    entityData.otherInformation.mappingsForCube.forEach((mapping) => {
      if (
        !mapping.mappingDefinition ||
        !mapping.referenceVariables ||
        !mapping.nonReferenceVariables
      )
        return;
      const obj = {
        mappingDef: {
          tid: mapping.mappingDefinition.tid,
          type: mapping.mappingDefinition.type,
          name: mapping.mappingDefinition.name,
          code: mapping.mappingDefinition.code,
          mappingType: mapping.mappingDefinition.mappingType,
        },
        refVars: mapping.referenceVariables.map((refVar) => {
          return {
            tid: refVar.tid,
            type: refVar.type,
            name: refVar.name,
            code: refVar.code,
          };
        }),
        nonRefVars: mapping.nonReferenceVariables.map((nonRefVar) => {
          return {
            tid: nonRefVar.tid,
            type: nonRefVar.type,
            name: nonRefVar.name,
            code: nonRefVar.code,
          };
        }),
      };
      mappings.push(obj);
    });
    return mappings;
  };

  handleSelectionChange = (tid) => {
    const { selectedItems } = this.state;
    const index = selectedItems.indexOf(tid);
    const newSelectedItems = selectedItems;

    if (index < 0) {
      newSelectedItems.push(tid);
    } else {
      newSelectedItems.splice(index, 1);
    }

    this.setState({
      selectedItems: newSelectedItems,
    });
  };

  toggleSelectAll = (filteredMappings) => {
    if (this.checkIfAllChecked(filteredMappings)) {
      this.setState({
        selectedItems: [],
      });
    } else {
      this.setState({
        selectedItems: filteredMappings
          .filter((mapping) => mapping.mappingDef.mappingType === "E")
          .map((item) => item.mappingDef.tid),
      });
    }
  };

  checkIfAllChecked = (filteredMappings) => {
    const { selectedItems } = this.state;
    return (
      selectedItems.length ===
      filteredMappings.filter(
        (mapping) => mapping.mappingDef.mappingType === "E"
      ).length
    );
  };

  exportToExcel = () => {
    const { detailViewStore } = this.props;
    const { selectedItems } = this.state;

    if (selectedItems.length < 1) return;

    detailViewStore.exportMappingDefinition(selectedItems);
  };

  handleCollapse = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  render() {
    const { entityData } = this.props;
    const { open, searchExpr, selectedItems } = this.state;

    const mappings = this.processEntityData(entityData);

    const filteredMappings = mappings.filter((mapping) => {
      const se = searchExpr.toLowerCase();
      if (!se) return true;
      return (
        (mapping.mappingDef &&
          mapping.mappingDef.code &&
          mapping.mappingDef.code.toLowerCase().includes(se)) ||
        (mapping.mappingDef &&
          mapping.mappingDef.name &&
          mapping.mappingDef.name.toLowerCase().includes(se)) ||
        (mapping.nonRefVars &&
          mapping.nonRefVars.some(
            (nrv) =>
              (nrv.code && nrv.code.toLowerCase().includes(se)) ||
              (nrv.name && nrv.name.toLowerCase().includes(se))
          )) ||
        (mapping.refVars &&
          mapping.refVars.some(
            (rv) =>
              (rv.code && rv.code.toLowerCase().includes(se)) ||
              (rv.name && rv.name.toLowerCase().includes(se))
          ))
      );
    });

    return (
      <div ref={this.props.innerRef} className="mapping custom-panel">
        <div className="custom-panel-heading spaced">
          <h4>Cube Variables Mapping</h4>
        </div>
        <Collapse in={open}>
          <div className="custom-panel-body">
            <div className="mapping-search-field-container">
              <InputGroup>
                <FormControl
                  type="text"
                  value={searchExpr}
                  onChange={(event) =>
                    this.handleSearchExprChange(event.target.value)
                  }
                  placeholder={"Name or Code"}
                />
                <InputGroup.Button>
                  <Button
                    onClick={() => {
                      this.handleSearchExprChange("");
                    }}
                  >
                    Clear
                  </Button>
                </InputGroup.Button>
              </InputGroup>
            </div>
            <div className="item-list-container">
              <Table striped bordered condensed hover className="mapping-table">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        onChange={() => this.toggleSelectAll(filteredMappings)}
                        style={{ marginRight: "10px" }}
                        checked={this.checkIfAllChecked(filteredMappings)}
                      />{" "}
                      Excel export
                      <span
                        className="glyphicon glyphicon-download-alt"
                        style={{ float: "right", cursor: "pointer" }}
                        onClick={() => this.exportToExcel()}
                      ></span>
                    </th>
                    <th>Mapping</th>
                    <th>Type</th>
                    <th className="non-reference">Non-Reference</th>
                    <th className="reference">Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMappings.map((mapping) => {
                    return mapping.mappingDef ? (
                      <tr key={mapping.mappingDef.tid}>
                        <td style={{ minWidth: "50px" }}>
                          {mapping.mappingDef.mappingType === "E" ? (
                            <input
                              type="checkbox"
                              onChange={() =>
                                this.handleSelectionChange(
                                  mapping.mappingDef.tid
                                )
                              }
                              checked={selectedItems.includes(
                                mapping.mappingDef.tid
                              )}
                            />
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <Link
                            to={`/view/${mapping.mappingDef.type}/${mapping.mappingDef.tid}`}
                            target="_blank"
                          >
                            {mapping.mappingDef.name} ({mapping.mappingDef.code}
                            )
                          </Link>
                        </td>
                        <td>{mapping.mappingDef.mappingType}</td>
                        <td>
                          {mapping.nonRefVars.map((nrv) => (
                            <p key={nrv.tid}>
                              <Link
                                to={`/view/${nrv.type}/${nrv.tid}`}
                                target="_blank"
                              >
                                <span>
                                  {nrv.name} ({nrv.code})
                                </span>
                              </Link>
                            </p>
                          ))}
                        </td>
                        <td>
                          {mapping.refVars.map((rv) => (
                            <p key={rv.tid}>
                              <Link
                                to={`/view/${rv.type}/${rv.tid}`}
                                target="_blank"
                              >
                                <span>
                                  {rv.name} ({rv.code})
                                </span>
                              </Link>
                            </p>
                          ))}
                        </td>
                      </tr>
                    ) : null;
                  })}
                </tbody>
              </Table>
            </div>
            <p>
              Type: <b>A</b> - Not enumerated (it can use an Algorithm);{" "}
              <b>E</b> - Enumerated
            </p>
          </div>
        </Collapse>
      </div>
    );
  }
}

export default Mapping;
